import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { getCenralLobyLocations, getCenralLobySelectedLocations, State } from '../state';
import * as CentralLocationSelectorActions from '../state/actions/lobby-central-view-location-selector.actions';
import { TranslationLoaderFacade } from 'src/app/admin/localization/translation-loader.facade';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lobby-central-views-location-selector',
  templateUrl: './lobby-central-views-location-selector.component.html',
  styleUrls: ['./lobby-central-views-location-selector.component.scss']
})
export class LobbyCentralViewsLocationSelectorComponent implements OnInit {
  allLocations$?: Observable<any>;
  selectedLocations$?: Observable<any[]>;

  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: this.translateService.instant('_General_Select_All_Text_'),
    unSelectAllText: this.translateService.instant('_General_Unselect_All_Ts_Text_'),
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  constructor(private store: Store<State>, private translationLoaderFacade: TranslationLoaderFacade, private translateService: TranslateService) { }

  ngOnInit() {
    this.store.dispatch(CentralLocationSelectorActions.loadAllLocations());
    this.allLocations$ = this.store.select(getCenralLobyLocations);
    this.selectedLocations$ = this.store.select(getCenralLobySelectedLocations);
  }

  onItemSelect(item: any) {
    this.store.dispatch(CentralLocationSelectorActions.setCentralLocationSelectorItemSelect({selectedLocation: item}));
    this.store.dispatch(CentralLocationSelectorActions.centralLocationSelectorItemChanged());
  }
  onSelectAll(items: any) {
    this.store.dispatch(CentralLocationSelectorActions.setCentralLocationSelectorItemSelectAll({selectedLocations: items}));
    this.store.dispatch(CentralLocationSelectorActions.centralLocationSelectorItemChanged());
  }

  onDeSelect(item: any) {
    this.store.dispatch(CentralLocationSelectorActions.setCentralLocationSelectorItemDeSelect({selectedLocation: item}));
    this.store.dispatch(CentralLocationSelectorActions.centralLocationSelectorItemChanged());
  }

  onDeSelectAll(items: any) {
    this.store.dispatch(CentralLocationSelectorActions.setCentralLocationSelectorItemDeSelectAll());
    this.store.dispatch(CentralLocationSelectorActions.centralLocationSelectorItemChanged());
  }

}
